<template>
    <div>
        <!-- <TheNavigationPanel/> -->
        <v-container>
            <v-snackbar
      v-model="snackbarVerify"
      :vertical="vertical"
      color="red"
      :timeout="10000" top
    >
      {{ text }}
      <v-btn
        color="white"
        text
        @click="snackbarVerify = false"
      >
        Close
      </v-btn>
    </v-snackbar>
            <v-toolbar flat></v-toolbar>
            <div>
                <h1 class="text-center" color="#444444">3 WAYS TO USE BITSHOPY</h1>
            </div>
            <v-row class="mt-12">
                <v-col cols="12" md="4" sm="12">
                    
                    <v-card
                        style="border: 1px orange solid"
                        flat
                        hover
                        class="mb-7 mx-auto"
                        max-width="344"
                    >
                        <v-card-title class="mt-n12 ml-12">
                            <v-avatar color="orange" size="90" class="mt-n3">
                                <v-icon dark large>mdi-account</v-icon>
                            </v-avatar>
                        </v-card-title>
                        <v-card-title class="mx-auto"><h3>SHOP & SAVE</h3></v-card-title>
                        <v-card-text class="text-center black-text">Search for items or browse our curated categories. Add to Cart and Set Your Discount at checkout</v-card-text>
                        <v-card-text class="text-center">
                            <v-btn text color='orange' router-link to="" class="font-weight-bold">Browse Items</v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                    
                    <v-card
                        max-width="344"
                        style="border: 1px teal solid"
                        flat
                        hover
                        class="mb-7 mx-auto"
                        
                    >
                        <v-card-title class="mt-n12 ml-12">
                            <v-avatar color="teal" size="90" class="mt-n3">
                                <v-icon dark large>mdi-apps</v-icon>
                            </v-avatar>
                        </v-card-title>
                        <v-card-title class="mx-auto"><h3>IMPORT WISH LIST</h3></v-card-title>
                        <v-card-text class="text-center black-text">Import your Amazon Wish List to quickly checkout. We'll keep track of items you add for easy reuse.</v-card-text>
                        <v-card-text class="text-center">
                            <v-btn text color='teal' router-link to="" class="font-weight-bold">Get Started</v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                    
                    <v-card
                        max-width="344"
                        style="border: 1px blue solid"
                        flat
                        hover
                        class="mb-7 mx-auto"
                    >
                        <v-card-title class="mt-n12 ml-12">
                            <v-avatar color="blue" size="90" class="mt-n3">
                                <v-icon dark large>mdi-bitcoin</v-icon>
                            </v-avatar>
                        </v-card-title>
                        <v-card-title class="mx-auto"><h3>EARN</h3></v-card-title>
                        <v-card-text class="text-center black-text">Not shopping? Earn Bitcoin by fulfilling Shoppers' Amazon orders.</v-card-text>
                        <v-card-text class="text-center">
                            <v-btn text color='blue' router-link to="" class="font-weight-bold">Learn More</v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
                
            </v-row>
            <div>
                <h2 color="#444444">Top 4 Crypto Twitter</h2>
            </div>
            <v-row>
                <v-col cols="12" md="3" sm="12">
                    <v-card max-width="344" class="mx-auto">
                        <v-card  flat class="mx-auto pa-8" width="300px">
                            <v-img
                                src="/crypt1.jpg"
                                class="white--text align-end"
                                height="250px"
                                contain
                            >
                            </v-img>
                        </v-card>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn icon>
                            <v-icon>mdi-heart</v-icon>
                            </v-btn>

                            <v-btn icon>
                            <v-icon>mdi-bookmark</v-icon>
                            </v-btn>

                            <v-btn icon>
                            <v-icon>mdi-share-variant</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3" sm="12">
                    <v-card max-width="344" class="mx-auto">
                        <v-card  flat class="mx-auto pa-8" width="300px">
                            <v-img
                                src="/crpt2.jpg"
                                class="white--text align-end"
                                height="250px"
                                contain
                            >
                            </v-img>
                        </v-card>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn icon>
                            <v-icon>mdi-heart</v-icon>
                            </v-btn>

                            <v-btn icon>
                            <v-icon>mdi-bookmark</v-icon>
                            </v-btn>

                            <v-btn icon>
                            <v-icon>mdi-share-variant</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3" sm="12">
                    <v-card max-width="344" class="mx-auto">
                        <v-card  flat class="mx-auto pa-8" width="300px">
                            <v-img
                                src="/crypt3.jpg"
                                class="white--text align-end"
                                height="250px"
                                contain
                            >
                            </v-img>
                        </v-card>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn icon>
                            <v-icon>mdi-heart</v-icon>
                            </v-btn>

                            <v-btn icon>
                            <v-icon>mdi-bookmark</v-icon>
                            </v-btn>

                            <v-btn icon>
                            <v-icon>mdi-share-variant</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3" sm="12">
                    <v-card max-width="344" class="mx-auto">
                        <v-card  flat class="mx-auto pa-8" width="300px">
                            <v-img
                                src="/crypt4.jpg"
                                class="white--text align-end"
                                height="250px"
                                contain
                            >
                            </v-img>
                        </v-card>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn icon>
                            <v-icon>mdi-heart</v-icon>
                            </v-btn>

                            <v-btn icon>
                            <v-icon>mdi-bookmark</v-icon>
                            </v-btn>

                            <v-btn icon>
                            <v-icon>mdi-share-variant</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            
        </v-container>
    </div>
</template>
<script>
// import TheNavigationPanel from '../components/TheNavigationPanel';
export default {
    components:{
        // TheNavigationPanel
    },
    data(){
        return{
            snackbarVerify:false,
            text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
        }
    },
    created(){
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
            this.snackbarVerify=true
        }
    }
}
</script>